import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getMedications = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/medications', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getMedication = id => {
  return api.http.get(`/medications/${id}`)
}

export const searchMedications = term => {
  return api.http.get('/medications/select_search', {
    params: {
      term
    }
  })
}

export const getSelectMedications = (term, callback) => {
  searchMedications(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteMedication = id => {
  return api.http.delete(`/medications/${id}`)
}

export const restoreMedication = id => {
  return api.http.put(`/medications/${id}/restore`)
}

export const editMedication = medication => {
  return api.http.put(`/medications/${medication._id}`, medication)
}

export const addMedication = medication => {
  return api.http.post('/medications', medication)
}



// WEBPACK FOOTER //
// ./src/api/medications.js